import React, { useState } from 'react';

import clsx from 'clsx';
import PropTypes from 'prop-types';
import { useDebouncedCallback } from 'use-debounce';

import { StyledSlider, useSliderStyles } from './styles';

export function Slider(props) {
  const {
    value: initialValue,
    className,
    classes: classesProp,
    labelValues = {},
    singleDiscrete,
    onChange,
    min = 0,
    max = 100,
    delay = 2,
    ...other
  } = props;

  const classes = useSliderStyles({ classes: classesProp });
  const [value, setValue] = useState(initialValue || (singleDiscrete ? min : [min, max]));
  const leftBoxValue = singleDiscrete ? labelValues[value] || value : labelValues[value[0]] || value[0];
  const rightBoxValue = singleDiscrete || !value[1] ? null : labelValues[value[1]] || value[1];

  const handleOnChangeDebounce = useDebouncedCallback((value, newValue) => {
    setValue(newValue);
    if (typeof onChange === 'function') {
      onChange({ target: { value } }, newValue);
    }
  }, delay);

  const handleChange = (event, newValue) => handleOnChangeDebounce(event.target.value, newValue);

  return (
    <div className={clsx(classes.root, className)}>
      <div className={clsx(classes.valueBox, 'Value-Box')}>{leftBoxValue}</div>
      <StyledSlider
        value={value}
        onChange={handleChange}
        className={'Range-Slider'}
        aria-labelledby='range-slider'
        getAriaValueText={value => value}
        min={min}
        max={max}
        {...other}
      />
      {!!rightBoxValue && <div className={clsx(classes.valueBox, 'Value-Box')}>{rightBoxValue}</div>}
    </div>
  );
}

Slider.propTypes = {
  /** The amount of time to wait before invoking onchange values */
  delay: PropTypes.number,
  classes: PropTypes.object,
  className: PropTypes.string,
  /** Default Value: Number if singleDiscrete, Array otherwise */
  defaultValue: PropTypes.oneOfType([PropTypes.number, PropTypes.array]),
  /** value: Number if singleDiscrete, Array otherwise */
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.array]),
  /** Boolean true if there is only one sliding value */
  singleDiscrete: PropTypes.bool,
  /** Function fired on value change */
  onChange: PropTypes.func,
  /** Minimum slider value */
  min: PropTypes.number,
  /** Maximum slider value */
  max: PropTypes.number,
  /** An override for the right slider value */
  labelValues: PropTypes.object,
};

export default Slider;
